import script from "./PortfolioStatsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioStatsRow.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioStatsRow.vue?vue&type=style&index=0&id=bad88f90&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bad88f90"]])

export default __exports__